module.exports = __webpack_public_path__ + "static/img/n9m4.8f90011.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/n9m/n9m4.jpg
// module id = M2gr
// module chunks = 1